import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import {
  Table, Row, Cell
} from '../../../components/table';
import { batchRequest } from '../../../../../api/ApiService';
import { Loader } from 'react-loaders';
import Auth from '../../../../../routes/Auth';

import { getProductRowColor, getProductNameColor } from '../../../../../api/PerformanceFeedback';

class RevenuesStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      netRevenues: 0,
      products: [],
      totalRevenues: 0,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    batchRequest([
      `${process.env.REACT_APP_API_URL}team/products/?round_lte=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}v2/games/targets/?course=${Auth.getCourseId()}`,
    ])
      .then(res => {
        const products = res[0].body;
        const productsFiltered = products.filter(i => Number(i.round) === roundId)
        const priceForecasts = res[1].body;
        const inventoryBalances = res[2].body;

        let totalRevenues = 0;
        for (let i = 0; i <= productsFiltered.length - 1; i++) {
          const priceForecast = priceForecasts.find(j => j.product === productsFiltered[i].id);
          const inventoryBalance = inventoryBalances.find(j => j.product === productsFiltered[i].id);
          productsFiltered[i].selling_price = priceForecast
            ? Number(priceForecast.price || 0)
            : 0;
          productsFiltered[i].available_for_sale = inventoryBalance
            ? Number(inventoryBalance.available_for_sale || 0)
            : 0;
          productsFiltered[i].total_revenues = productsFiltered[i].selling_price * productsFiltered[i].available_for_sale;
          totalRevenues += productsFiltered[i].total_revenues;
        }

        const targets = res[3].body;
        const currentRoundTargets = targets.find(i => i.round_number === activeRound);

        this.setState({
          loaded: true,
          netRevenues: Number(currentRoundTargets.net_revenues || 0),
          products: productsFiltered,
          totalRevenues,
        })
      })
      .catch(err => { });
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  render() {
    const {
      loaded,
      netRevenues,
      products,
      totalRevenues,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="REVENUES"
        previousShownErrors={previousShownErrors}
        alertText="Your product's selling price and/or units available for sale were too low."
        paragraph1={(
          <Fragment>
            As you can see below, the selling price (set by Marketing) and the units available
            for sale (set by Operations) reflect an expected sales value that is lower than the
            revenue target of <b>${Number((netRevenues / 1000000).toFixed(2))}M</b>.
          </Fragment>
        )}
        visual={(
          <Table>
            <Row background="#2a4169">
              <Cell color="#ffffff" />
              <Cell color="#ffffff">Selling Price</Cell>
              <Cell color="#ffffff">Available For Sale Inventory</Cell>
              <Cell color="#ffffff">Total Expected Revenues</Cell>
            </Row>
            {products.map((product, index) => (
              <Row background={getProductRowColor(index)} key={index}>
                <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{product.name}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">${product.selling_price.toFixed(2)}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{this.numberWithCommas(product.available_for_sale)}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">${this.numberWithCommas(product.total_revenues)}</Cell>
              </Row>
            ))}
            <Row>
              <Cell color="rgba(0, 27, 59, 0.94)">Total Expected Revenues</Cell>
              <Cell />
              <Cell />
              <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">${this.numberWithCommas(totalRevenues)}</Cell>
            </Row>
          </Table>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default RevenuesStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/revenues/step2.js